export * from './ArrowRoundTimeBackIcon';
export * from './ArrowRoundTimeBackIcon16Light';
export * from './ArrowRoundTimeBackIcon16Regular';
export * from './ArrowRoundTimeBackIcon16Solid';
export * from './ArrowRoundTimeBackIcon20Light';
export * from './ArrowRoundTimeBackIcon20Regular';
export * from './ArrowRoundTimeBackIcon20Solid';
export * from './ArrowRoundTimeBackIcon24Regular';
export * from './ArrowRoundTimeBackIcon24Solid';
export * from './ArrowRoundTimeBackIcon32Regular';
export * from './ArrowRoundTimeBackIcon64Regular';
